import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import ScrollToTop from "./components/ScrollTop/ScrollToTop.js";
import Services from "./components/Services/Services";
import Homologation from "./components/Homologation/Homologation";
import Footer from "./components/Footer/Footer";
import About from "./components/About/About";
import ReachUs from "./components/ReachUs/ReachUs";
import KnowMore from "./components/KnowMore/KnowMore";
import Login from "./components/Login/Login";
import ITNetworkingServices from "./components/ITNetworkingServices/ITNetworkingServices";
import OtherServices from "./components/OtherServices/OtherServices";
import EngineeringServices from "./components/EngineeringServices/EngineeringServices";
import Prototyping from "./components/Prototyping/Prototyping";
import ValueEngineering from "./components/ValueEngineering/ValueEngineering";
import MainAbout from "./components/MainAbout/MainAbout";
import OtherServiceFirst from "./components/OtherServiceFirst/OtherServiceFirst";
import DashboardIframe from "./components/DashboardIframe/DashboardIframe";

import "./App.css";
import ITNetworkFirst from "./components/ITNetworkFirst/ITNetworkFirst";
import EngineeringServiceFirst from "./components/EngineeringServiceFirst/EngineeringServiceFirst";
import ChatbotApplication from "./components/ChatbotApplication/ChatbotApplication";
import ITConsulting from "./components/ITConsulting/ITConsulting";
import SoftwareDevelopment from "./components/SoftwareDevelopment/SoftwareDevelopment";
import ThreeDModeling from "./components/ThreeDModeling/ThreeDModeling";
import TestingAndQA from "./components/TestingAndQA/TestingAndQA";
import WebsiteDesign from "./components/WebsiteDesign/WebsiteDesign";
import CircularDesignEngg from "./components/CircularDesignEngg/CircularDesignEngg";
import CAEAnalysis from "./components/CAEAnalysis/CAEAnalysis";
import StylingProductDesign from "./components/StylingProductDesign/StylingProductDesign";
import Drafting from "./components/Drafting/Drafting";
import StaffingAndTrainingServices from "./components/StaffingAndTrainingServices/StaffingAndTrainingServices";
import PlantLayoutPlanningServices from "./components/PlantLayoutAndPlanningServices/PlantLayoutAndPlanningServices";
import Reachusfirst from "./components/Reachusfirst/Reachusfirst";
import Broucher from "./components/Broucher/Broucher";
import Gallery from "./components/Gallery/Gallery";
import HomologationFirst from "./components/HomologationFirst/HomologationFirst";
import KnowMoreFirstPage from "./components/KnowMoreFirstPage/KnowMoreFirstPage.js";
import CircularDesignNew from "./components/CircularDesignNew/CircularDesignNew";
import "./App.css";
import Broucherfirst from "./components/Broucherfirst/Broucherfirst";
import Feedbackform from "./components/Feedbackform/Feedbackform";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";

function App() {
  function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }
  useEffect(() => {
    let isMounted = true;
    let subscriptionInterval;

    function scheduleTestTrigger(secondsFromNow) {
      const now = new Date();
      const triggerTime = new Date(now.getTime() + secondsFromNow * 1000);

      const timeUntilTrigger = triggerTime.getTime() - now.getTime();

      setTimeout(() => {
        checkSubscription();
        setInterval(checkSubscription, 24 * 60 * 60 * 1000);
      }, timeUntilTrigger);
    }

    async function initPush() {
      if (!isMounted) return;
      try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
          return;
        }

        const registration =
          await navigator.serviceWorker.register("/service-worker.js");

        const existingSubscription =
          await registration.pushManager.getSubscription();
        if (existingSubscription) {
          const res = await fetch(
            "https://sukalpatechsolutions.com/api/check-subscription",
            {
              method: "POST",
              credentials: "include",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ endpoint: existingSubscription.endpoint }),
            },
          );
          const { exists } = await res.json();
          if (exists) {
            return;
          }
        }

        const vapidResponse = await fetch(
          "https://sukalpatechsolutions.com/api/vapidPublicKey",
        );
        if (!vapidResponse.ok) {
          throw new Error(`Failed to get VAPID key: ${vapidResponse.status}`);
        }
        const { publicKey } = await vapidResponse.json();

        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(publicKey),
        });

        const res = await fetch(
          "https://sukalpatechsolutions.com/api/subscribe",
          {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(subscription.toJSON()),
          },
        );

        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(`Subscription failed: ${errorText}`);
        }
      } catch (err) {
        console.error("Push init error:", err);
      }
    }

    async function checkSubscription() {
      if (!isMounted) return;
      try {
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.getSubscription();
        if (subscription) {
          const res = await fetch(
            "https://sukalpatechsolutions.com/api/check-subscription",
            {
              method: "POST",
              credentials: "include",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ endpoint: subscription.endpoint }),
            },
          );
          const { exists } = await res.json();
          if (!exists) {
            await initPush();
          }
        }
      } catch (err) {
        console.error("Subscription check error:", err);
      }
    }

    initPush();
    subscriptionInterval = setInterval(checkSubscription, 1 * 60 * 1000);

    scheduleTestTrigger(30);

    return () => {
      isMounted = false;
      clearInterval(subscriptionInterval);
    };
  }, []);

  return (
    <Router>
      <div className="App">
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/ScrollTop" element={<ScrollToTop />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/Homologation" element={<Homologation />} />
          <Route path="/ReachUs" element={<ReachUs />} />
          <Route path="/KnowMore" element={<KnowMore />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/dashboard" element={<DashboardIframe />} />
          <Route path="/MainAbout" element={<MainAbout />} />
          <Route path="/OtherServices" element={<OtherServices />} />
          <Route path="/ITNetworkFirst" element={<ITNetworkFirst />} />
          <Route path="/ValueEngineering" element={<ValueEngineering />} />
          <Route
            path="/EngineeringServiceFirst"
            element={<EngineeringServiceFirst />}
          />
          <Route path="/OtherServiceFirst" element={<OtherServiceFirst />} />
          <Route path="/ChatbotApplication" element={<ChatbotApplication />} />
          <Route path="/ITConsulting" element={<ITConsulting />} />
          <Route path="/ThreeDModeling" element={<ThreeDModeling />} />
          <Route
            path="/SoftwareDevelopment"
            element={<SoftwareDevelopment />}
          />
          <Route path="/TestingAndQA" element={<TestingAndQA />} />
          <Route path="/WebsiteDesign" element={<WebsiteDesign />} />
          <Route path="/CircularDesignEngg" element={<CircularDesignEngg />} />
          <Route path="/CAEAnalysis" element={<CAEAnalysis />} />
          <Route path="/Drafting" element={<Drafting />} />
          <Route
            path="/StaffingAndTraining"
            element={<StaffingAndTrainingServices />}
          />
          <Route
            path="/StylingProductDesign"
            element={<StylingProductDesign />}
          />
          <Route
            path="/PlantLayoutAndPlanningServices"
            element={<PlantLayoutPlanningServices />}
          />
          <Route path="/CircularDesignNew" element={<CircularDesignNew />} />
          <Route path="/Brouchure" element={<Broucher />} />
          <Route path="/Broucherfirst" element={<Broucherfirst />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/ReachUs" element={<ReachUs />} />
          <Route path="/Reachusfirst" element={<Reachusfirst />} />
          <Route path="/HomologationFirst" element={<HomologationFirst />} />
          <Route path="/Feedbackform" element={<Feedbackform />} />
          <Route path="/KnowMoreFirstPage" element={<KnowMoreFirstPage />} />
          <Route path="/Broucher" element={<Broucher />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />

          <Route
            path="/EngineeringServices"
            element={<EngineeringServices />}
          />
          <Route path="/Prototyping" element={<Prototyping />} />
          <Route
            path="/ITNetworkingServices"
            element={<ITNetworkingServices />}
          />
          <Route path="*" element={<h1>404 Not Found</h1>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
